import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { LoginService } from './app/service/auth-service/login.service';
import { routes } from './app/app.routes';
import { GreenOrangePreset } from './green.preset';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { MessageInterceptor } from './core/interceptor/message.interceptor';
import { TokenService } from './app/core/service/token.service';
import { take } from 'rxjs';
import * as Sentry from '@sentry/angular';

function initializeAuth(loginService: LoginService) {
  return () => new Promise<void>((resolve) => {
    loginService.initializeAuthState();
    // Wait for the auth state to be initialized
    loginService.authUser$.pipe(take(1)).subscribe(() => {
      resolve();
    });
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: GreenOrangePreset,
        options: {
          darkModeSelector: 'dark-mode'
        }
      }
    }),
    importProvidersFrom(HttpClientModule),
    MessageService,
    LoginService,
    TokenService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MessageInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [LoginService],
      multi: true
    },
    // Sentry Error Handler
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false, // Set to true to show a feedback dialog
      }),
    },
    // Sentry Trace Service
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // Ensure TraceService is initialized
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};